import React from 'react'
import PropTypes from 'prop-types'
import Drawer from 'components/common/Drawer'
import CommunicationPreferencesForm from '../CommunicationPreferencesForm'
import CommunicationPreferencesView from '../CommunicationPreferencesView'
import ProvidePhoneNumberModal from '../ProvidePhoneNumberModal'

const CommunicationPreferencesDrawer = ({
  appointmentReminder,
  accountContactDetails,
  savingAndDiscounts,
  editMode,
  editModeOn,
  editModeOff,
  setFocusScopeRef,
  handleUpdatePreferences,
  providePhoneNumberInstruction
}) =>
  <Drawer title="Communication Preferences" withHeading accordion expandedByDefault>
    {
      editMode ?
        <CommunicationPreferencesForm
          appointmentReminder={ appointmentReminder }
          accountContactDetails={ accountContactDetails }
          savingAndDiscounts={ savingAndDiscounts }
          setFocusScopeRef={ setFocusScopeRef }
          onSubmit={ handleUpdatePreferences }
          onCancel={ editModeOff } /> :
        <CommunicationPreferencesView
          appointmentReminder={ appointmentReminder }
          savingAndDiscounts={ savingAndDiscounts }
          onEdit={ editModeOn } />
    }
    <ProvidePhoneNumberModal instruction={ providePhoneNumberInstruction } />
  </Drawer>

export default CommunicationPreferencesDrawer

CommunicationPreferencesDrawer.propTypes = {
  accountContactDetails: PropTypes.shape(),
  appointmentReminder: PropTypes.shape(),
  editMode: PropTypes.bool,
  editModeOff: PropTypes.func,
  editModeOn: PropTypes.func,
  handleUpdatePreferences: PropTypes.func,
  providePhoneNumberInstruction: PropTypes.string,
  savingAndDiscounts: PropTypes.shape(),
  setFocusScopeRef: PropTypes.func
}
